import React from 'react';
import { connect } from 'react-redux';
import FormTab from '../../../core/form/components/FormTab';
import FormBase from '../../../core/form/components/FormBase';
import PageTitle from '../../../core/form/components/PageTitle';

import ProbesLsv from '../components/ProbesLsv';

import { Nav, TabContent, TabPane } from 'reactstrap';

class Probes extends FormBase {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: '1',
      errorMessage: null,
      probes: [],
    };

    this.toggleTab = this.toggleTab.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  toggleTab(tab, tag) {
    this.setState({ activeTab: tab });

    switch (tag) {
      default:
        break;
    }
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { activeTab, probes } = this.state;

    const title = 'Profit Probes';

    return (
      <div className="p-3 h-100">
        <PageTitle title={title} iconName="ufo-beam" />
        <Nav tabs className="mt-2">
          <FormTab
            caption="All Probes"
            tabId="1"
            activeTab={activeTab}
            toggle={this.toggleTab}
            tabTag="income"
          />
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1" className="mb-2 p-1">
            <ProbesLsv rows={probes} history={this.props.history} />
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

const mapStoreToProps = (store) => {
  return {
    realm: store.realm,
  };
};

export default connect(mapStoreToProps)(Probes);
